export default {
  props: ['render', 'column', 'data'],
  setup(props: Record<any, any>) {
    return () => props.render(props.column, props.data)
  }
}
